import { render, staticRenderFns } from "./VolunteerMatchSummaryStandard.vue?vue&type=template&id=77cf9794"
import script from "./VolunteerMatchSummaryStandard.vue?vue&type=script&lang=ts"
export * from "./VolunteerMatchSummaryStandard.vue?vue&type=script&lang=ts"
import style0 from "./VolunteerMatchSummaryStandard.vue?vue&type=style&index=0&id=77cf9794&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports